var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lock",
    clipPath: "url(#clip0_8264_1356)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.2161 9.22119H4.54948C3.629 9.22119 2.88281 9.96738 2.88281 10.8879V16.7212C2.88281 17.6417 3.629 18.3879 4.54948 18.3879H16.2161C17.1366 18.3879 17.8828 17.6417 17.8828 16.7212V10.8879C17.8828 9.96738 17.1366 9.22119 16.2161 9.22119Z",
    stroke: "#8A8A8A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.21631 9.22119V5.88786C6.21631 4.78279 6.6553 3.72298 7.4367 2.94158C8.2181 2.16018 9.27791 1.72119 10.383 1.72119C11.488 1.72119 12.5479 2.16018 13.3293 2.94158C14.1107 3.72298 14.5496 4.78279 14.5496 5.88786V9.22119",
    stroke: "#8A8A8A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8264_1356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.382812 0.0546875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon-lock.7062d4febfec0a0f3e4d751afadd640e.svg";
export { ForwardRef as ReactComponent };